module.exports = __webpack_public_path__ + "static/media/lennox.197570cf.jpg";